<script lang="ts" setup>
import * as _ from 'lodash-es'
import FloatLabel from 'primevue/floatlabel'
import { formatList } from '@/lib/helpers'

const filterInputStore = useFilterInputStore()
const { getOccupations, getPlaces } = useRemoteData()

const clonedFilterData = useClonedObject(filterInputStore.values)

function onCancel() {
  clonedFilterData.cancel()
}

function onCommit() {
  clonedFilterData.commit()
}

const options = ['occupation', 'placeOfActivity'] as const

const isActive = computed(() => options.some(option => filterInputStore.isOptionActive[option]))

function onClear() {
  filterInputStore.reset({ include: options })
}
</script>

<template>
  <FilterGroup
    name="Tätigkeit"
    :active="isActive"
    @cancel="onCancel"
    @commit="onCommit"
    @clear="onClear"
  >
    <template #icon>
      <!-- prettier-ignore -->
      <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="m132.5 34.3 97.2 97.2-46.5 46.5 72.8 72.9 72.8-72.9-46.5-46.6 97.3-97.1L512 166.8v130.4l-31.8 32.1-76.2-76.2-73 72.9 110.8 110.8-75 75L256 401.2 145.2 512 70 436.8l110.7-110.9-72.8-72.7-76.2 76.1-31.8-32V166.7L132.5 34.3Zm72.8 316.1-86.2 86.4 26 26 86.4-86.2-26.2-26.2Zm-46.7-147.9-26 26.1L366.7 463l26-26.1-234.2-234.3Zm194.7 0-72.8 72.9 26 26 73-72.8-26.2-26Zm26.3-119.2-48.3 48.2 146 146V181l-97.7-97.8Zm-247 0-98 97.8v96.4l48.9-48.8v-.1l63-62.9 34.2-34.2-48.2-48.2Z"/></svg>
    </template>
    <template #body>
      <FloatLabel>
        <RemoteAutoComplete
          v-model="clonedFilterData.data.occupation"
          :get-suggestions="getOccupations"
          option-label="name"
          multiple
        />
        <label>Tätigkeit</label>
      </FloatLabel>
      <FloatLabel>
        <RemoteAutoComplete
          v-model="clonedFilterData.data.placeOfActivity"
          :get-suggestions="getPlaces"
          option-label="name"
          multiple
        />
        <label>Wirkungsort</label>
      </FloatLabel>
    </template>
    <template #summary>
      <div v-if="filterInputStore.isOptionActive.occupation">
        Tätigkeit:
        <strong>{{ formatList(_.map(filterInputStore.values.occupation, 'name')) }}</strong>
      </div>
      <div v-if="filterInputStore.isOptionActive.placeOfActivity">
        Wirkungsort:
        <strong>{{ formatList(_.map(filterInputStore.values.placeOfActivity, 'name')) }}</strong>
      </div>
    </template>
  </FilterGroup>
</template>

<style scoped></style>
